'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.changeResource = changeResource;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* REDUX MAINTAIN RESOURCES PAGE */

var CHANGE_RESOURCE = 'CHANGE_RESOURCE';

/*
 * module is the module number, 0 to 5, 5 being booster
 * item is the nth item in the module's resource
 * page is the nth page we want from that resource
 */
var initialState = {
  module: 0,
  item: 0
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case CHANGE_RESOURCE:
      return (0, _extends3.default)({}, state, {
        module: action.module,
        item: action.item
      });
    default:
      return state;
  }
}

function changeResource(mod, it) {
  return {
    type: CHANGE_RESOURCE,
    module: mod,
    item: it
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/resources.js
// module id = 72
// module chunks = 0